/**
 * 注文コード割当（部門別）選定済商品数一覧情報を管理するクラス
 *
 * @export KYMW2000Model
 * @class KYMW2000Model
 */
export class OrderNumQuotaSelectedSummary {
  constructor(
    public SelectedNumList: {
      ClassCode: string,
			ClassName: string,
			IbarakiGoodsCount: number,
			TochigiGoodsCount: number,
			GunmaGoodsCount: number,
			ChibaGoodsCount: number,
			SaitamaGoodsCount: number,
			TokyoGoodsCount: number,
			NaganoGoodsCount: number,
			NiigataGoodsCount: number,
    }[],
    public SelectedTotalNum: {
			IbarakiGoodsCount: number,
			TochigiGoodsCount: number,
			GunmaGoodsCount: number,
			ChibaGoodsCount: number,
			SaitamaGoodsCount: number,
			TokyoGoodsCount: number,
			NaganoGoodsCount: number,
			NiigataGoodsCount: number,
    },
		public MaxNum: {
			IbarakiGoodsCount: number,
			TochigiGoodsCount: number,
			GunmaGoodsCount: number,
			ChibaGoodsCount: number,
			SaitamaGoodsCount: number,
			TokyoGoodsCount: number,
			NaganoGoodsCount: number,
			NiigataGoodsCount: number,
    },
  ) {}
}